var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00106 16C7.71772 16 7.48022 15.9042 7.28856 15.7125C7.09689 15.5208 7.00106 15.2833 7.00106 15V9L1.20106 1.6C0.951057 1.26667 0.913557 0.916667 1.08856 0.55C1.26356 0.183333 1.56772 0 2.00106 0H16.0011C16.4344 0 16.7386 0.183333 16.9136 0.55C17.0886 0.916667 17.0511 1.26667 16.8011 1.6L11.0011 9V15C11.0011 15.2833 10.9052 15.5208 10.7136 15.7125C10.5219 15.9042 10.2844 16 10.0011 16H8.00106ZM9.00106 8.3L13.9511 2H4.05106L9.00106 8.3Z",
    fill: "#399E79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAlt);
export default __webpack_public_path__ + "static/media/filter_alt.72895744c93cd31a070cd2db024a85be.svg";
export { ForwardRef as ReactComponent };